import firebaseAnalytics from './configFirebase';
import TagManager from 'react-gtm-module';
import ReactPixel from 'react-facebook-pixel';

const trackEvent = (event) => {
  const { eventName, ...params } = event;
  if (!eventName) return;
  try {
    firebaseAnalytics.logEvent(eventName, params);
    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        ...params
      }
    });
    ReactPixel.trackCustom(eventName, params);
  } catch (error) {
    console.log(`analytics_${eventName}_fails`);
  }
};

export default trackEvent;
